<template>
    <div class="h6">{{ $t('views.onboarding.title') }}: {{$t('common.step_1')}} 4/4</div>
    <h1 class="h2">{{ $t('views.onboarding.titles.4') }}</h1>
    <p class="p">{{ $t('views.onboarding.descriptions.4') }}</p>
    <div class="form-type-0">
        <CustomSuggest 
            inputKey="text_search_onboarding"
            :fetchSuggestionsFn="fetchSuggestions"
            @select-suggestion="loadCompanies"
            :showLabel="true"
            :showDescription="false"
            ref="suggest"
        />
    </div>
    <p class="p">{{ $t('views.onboarding.descriptions.4_2') }}</p>
    <ul class="list-icon-pos">
        <li class="phone" v-if="phone && phone_url"><a :href="'tel:' + phone_url" target="_blank" rel="external noopener">{{phone}}</a></li>
        <li class="email" v-if="email"><a :href="'mailto:' + email" target="_blank" rel="external noopener">{{email}}</a></li>
        <li class="url" v-if="url"><a :href="url" target="_blank" rel="external noopener">{{url}}</a></li>
    </ul>
    <div class="notice">{{$t('views.onboarding.notices.contact')}}</div>
</template>

<script>
    import { fetchSuggestions } from '@/services/freeApi';
    import i18n from '@/plugins/i18n';
    import { useAccountStore } from '@/stores/account';
    import { useCompaniesStore } from '@/stores/companies';
    import { usePopupStore } from '@/stores/utils/popup';
    import CustomSuggest from '@/components/inputs/CustomSuggest';

    export default {
        name: 'OnboardingStep4',
        components: {
            CustomSuggest,
        },
        data() {
            return {
                phone_nl: process.env.VUE_APP_PHONE_NL || process.env.VUE_APP_PHONE || false,
                phone_intl: process.env.VUE_APP_PHONE || false,
                phone_url: process.env.VUE_APP_PHONE_URL || false,
                email: process.env.VUE_APP_EMAIL || false,
                url: process.env.VUE_APP_URL_MAIN || false,
            }
        },
        computed: {
            accountStore() {
                return useAccountStore();
            },
            companiesStore() {
                return useCompaniesStore();
            },
            currentLocale() {
                return i18n.global.locale === 'nl' ? 'nl' : 'en';
            },
            phone() {
                return this.currentLocale === 'nl' ? this.phone_nl : this.phone_intl;
            }
        },
        methods: {
            async fetchSuggestions(query) {
                try {
                    const response = await fetchSuggestions({
                        type: 'text',
                        q: query
                    });
                    return response.data.suggest.map(suggestion => ({
                        value: suggestion.term,
                        text: suggestion.term,
                    }));
                } catch {
                    return [];
                }
            },
            async loadCompanies(suggestion) {
                const value = suggestion.value;
                if(!value) return;

                const text = { includes: [], excludes: [], required: [], custom: '' };

                if(value.includes(',')) {
                    const values = value.split(',');
                    
                    for (const val of values) {
                        if (val.trim() !== '') {
                            text.includes.push({value: val.trim(), text: val.trim()});
                        }
                    }
                } else {
                    text.includes.push({value: value.trim(), text: value.trim()});
                }

                this.companiesStore.updateOptions({text});

                await this.accountStore.updateAccount({
                    onboarding_status: 1
                });

                this.startProspectingPopup();
            },
            startProspectingPopup() {
                usePopupStore().showPopup('confirm', {
                    title: 'popups.onboarding_complete.title',
                    description: 'popups.onboarding_complete.description',
                    btnConfirm: "popups.onboarding_complete.button_confirm",
                    closeable: false,
                    confirmFunction: () => {
                        this.companiesStore.routeToMode('all');
                    },
                });
            },
        }
    }
</script>
